import { render, staticRenderFns } from "./AuditLog.vue?vue&type=template&id=20c81dc8"
import script from "./AuditLog.vue?vue&type=script&lang=js"
export * from "./AuditLog.vue?vue&type=script&lang=js"
import style0 from "./AuditLog.vue?vue&type=style&index=0&id=20c81dc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports